import './AdMenteeStyle.css'
import React, { useEffect, useRef } from 'react'
import Button from '../../../components/Button/Button';
import SearchBar from '../../../components/SearchBar/SearchBar';
import { useNavigate } from 'react-router-dom';
import FilterPasscall from '../../../components/FilterPasscall/FilterPasscall';
import { useState } from 'react';
import Deletepoup from '../../../components/Popups/Deletepoup/Deletepoup';
import { useDispatch, useSelector } from 'react-redux';
import { adminData, clearState, clearUsers, deleteUser, getAllM, getAllMentees, getAllMenteesenteesgetAllMentees } from '../../../reducer/adminSlice';
import PageLoader from "../../../components/loaders/PageLoader/PageLoader";
import DatanotFound from '../../../components/DatanotFound/DatanotFound';
import moment from 'moment';
import Paginationarrow from '../../../components/Paginationarrow/Paginationarrow';
import Dorpwoncustom from '../../../components/Dorpwoncustom/Dorpwoncustom';
import Skeleton from 'react-loading-skeleton';


const AdMentee = () => {

    const qualificationOptions = [
        {
            label: 'Working Professional',
            value: 'work'
        },
        {
            label: 'Student',
            value: 'student'
        },
    ];

    //filter popup
    const [filterpoup, setfilterpoup] = useState()
    // delete popup
    const [deleteToggler, setDeleteToggler] = useState();

    //Search states
    const [search, setSearch] = useState("");

    //Filter states
    const [qualification, setQualification] = useState("");

    //Temporary states
    const [selectedMentee, setSelectedMentee] = useState("");
    const [totalCount, setTotalCount] = useState(0);

    //Load more states
    const [index, setIndex] = useState(1);
    const [totalMentees, setTotalMentees] = useState([]);

    //Toast states
    const [isShowError, setIsShowError] = useState(false);
    const [errMessage, setErrMessage] = useState("");

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { isMenteeFetching, isLoaderFetching, isSuccess, isError, errorMessage, allMentees, allPrograms } = useSelector(adminData);

    //Delete Functions
    const handleDeleteMentee = () => {
        dispatch(deleteUser(selectedMentee));
    };

    const handleCloseDelete = () => {
        setSelectedMentee("");
        setDeleteToggler(false);
    };

    //Search functions
    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearch(value);
    };

    const handleSearch = (e) => {
        setTotalMentees([]);
        setIndex(1);
        dispatch(getAllMentees({ search, user: "mentee", qualification }));
    };

    const handleSearchPress = (e) => {
        if (e.key === "Enter") {
            setTotalMentees([]);
            setIndex(1);
            dispatch(getAllMentees({ search, user: "mentee", qualification }));
        }
    };

    //Filter Functions
    const handleQualificationFilter = (e) => {
        setQualification(e);
    };

    const handleShowFilters = () => {
        setTotalMentees([]);
        setIndex(1);
        setfilterpoup(false);
        dispatch(getAllMentees({ search, user: "mentee", qualification }));
    };

    //Load more functions
    const handleLoadMore = () => {
        setIndex(prev => prev + 1);
        dispatch(getAllMentees({ search, user: "mentee", qualification, index: index + 1 }));
    };

    //Load more useEffects
    useEffect(() => {
        if (index === 1 && allMentees?.users?.length > 0) setTotalMentees(allMentees?.users);
        if (index !== 1 && allMentees?.users?.length > 0) setTotalMentees(prev => [...prev, ...allMentees?.users]);
        if (allMentees?.totalCount) setTotalCount(allMentees?.totalCount);
    }, [allMentees]);

    //Filter useEffects
    // useEffect(() => {
    //     setTotalMentees([]);
    //     setIndex(1);
    //     dispatch(getAllMentees({search, user: "mentee", qualification}));
    // },[qualification]);

    useEffect(() => {
        dispatch(getAllMentees({ user: "mentee" }));
        return () => {
            dispatch(clearUsers());
        }
    }, [])

    useEffect(() => {
        if (isSuccess) {
            setTotalMentees([]);
            setIndex(1);
            dispatch(getAllMentees({ user: "mentee" }));
            dispatch(clearState());
        }
    }, [isSuccess])

    useEffect(() => {
        if (isError) {
            // setTotalMentees(allMentees);
            setIndex(1);
            setIsShowError(true);
            setErrMessage(errorMessage);
            // dispatch(getAllMentees({user:"mentee"}));
            dispatch(clearState());
        }
    }, [isError]);

    const targetRef = useRef(null);

    useEffect(() => {

        const element = document.querySelector(".CallHistoryTabledata");
        const element1 = document.querySelector(".innerdiv");

        const handleScroll = () => {
            if (targetRef.current) {
                const { top } = targetRef.current.getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;

                if (top <= windowHeight) {
                    handleLoadMore();
                }
            }
        };

        element.addEventListener('scroll', handleScroll);
        element1.addEventListener('scroll', handleScroll);

        return () => {
            element.removeEventListener('scroll', handleScroll);
            element1.removeEventListener('scroll', handleScroll);
        };
    }, [handleLoadMore]);

    return (
        <>
            {isLoaderFetching && <PageLoader />}
            <FilterPasscall isActive={filterpoup} setIsActive={setfilterpoup} qualificationOptions={qualificationOptions} onClick={handleShowFilters} handleChange={handleQualificationFilter} value={qualification} />
            <Deletepoup isActive={deleteToggler} handleClose={handleCloseDelete} handleDelete={handleDeleteMentee} />
            <div className="callHIstoryWrap mbfixAdtable">

                <div className="headingwrap flex-between">
                    <div>
                        <h2 className='heading-2 mb6'>Mentees</h2>
                        {isMenteeFetching ? <Skeleton width={"80px"} /> : <p className='text3'>Total {totalCount ?? 0}</p>}
                    </div>
                </div>

                <div className={`commonTableWrapper AdcommonWrapperforAll`}>
                    <div className="FaqUserFiltter flex-between">
                        {isMenteeFetching ? <Skeleton width={"280px"} height={"42px"} /> : <SearchBar className={"searchbardesign"} placeholder={'Search by Name'} value={search} onChange={handleSearchChange} onClick={handleSearch} onKeyDown={handleSearchPress} />}
                        <div className="FilterButtonPast flex gap-10" >
                            {<input type='text' placeholder={`Showing ${totalMentees?.length ?? 0} out of ${totalCount}`} disabled className='disabledInput' />}
                            {<Button name={'Filters'} src={'/assets/img/Filter list.png'} className={'filterbtn'} onClick={() => setfilterpoup(true)} />}
                        </div>
                    </div>

                    <div className={`CallHistoryTabledata mt20 fixmenteegap1`}>

                        <div className="outerdiv">
                            <table>
                                <thead>
                                    <tr className='headingTabletr'>
                                        <th>Name</th>
                                        <th> <div className='headingtablediv'>Date of joining</div> </th>
                                        <th>Email</th>
                                        <th> <div className='headingtablediv'>Contact number</div> </th>
                                        <th><div className='flex headingtablediv'>
                                            No. of calls taken
                                            {/* <div className='iconsdatadev ml4'>
                                            <img src="/assets/img/icons/up.png" alt="" />
                                            <img src="/assets/img/icons/down.png" alt="" />
                                        </div> */}
                                        </div>
                                        </th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                            </table>
                        </div>

                        <div className="innerdiv">
                            <table>
                                <tbody>
                                    {totalMentees?.length > 0 ? totalMentees?.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <div className="tableBox">
                                                    <div className='Adminprofileimageuser'>
                                                        <img src={item?.profileImg ? item?.profileImg : "/assets/img/User.png"} alt="" className='pointer' />
                                                    </div>
                                                    <div className='Namedetails'>
                                                        <h4 className='namelink mb4 navigatetext' onClick={() => navigate(`/admin/mentee-profile/${item?.id}`)}>{item?.firstName ? `${item?.firstName} ${item?.lastName}` : "---"}</h4>
                                                        <p className="text2">{item?.profession?.title ? item?.profession?.title === "work" ? 'Working Professional' : 'Student' : "---"}</p>
                                                    </div>
                                                </div>
                                            </td>

                                            <td>
                                                <div className='tableBox dsblock'>
                                                    <h4>{item?.createdAt ? moment(item?.createdAt).format("DD MMMM") : "---"}</h4>
                                                    <p className='text2'>{item?.createdAt ? moment(item?.createdAt).format("dddd") : "---"}</p>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.email ? item?.email : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">
                                                    <h4>{item?.mobileNumber ? item?.mobileNumber : "---"}</h4>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="tableBox">

                                                    <h4>{item?.totalCalls ? item?.totalCalls : 0}</h4>

                                                </div>
                                            </td>

                                            <td>
                                                <div className="tableBox">
                                                    <div className="tableBox">
                                                        <span className='tooltip pointer' data-tooltip="Delete" onClick={() => { setDeleteToggler(true); setSelectedMentee(item?.id) }} >
                                                            <img src="/assets/svg/trash.svg" alt="" />
                                                        </span>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )) : !isMenteeFetching && <DatanotFound />}
                                    {isMenteeFetching &&
                                        <>
                                            {[1, 2, 3, 4].map(item => (
                                                <tr key={item}>
                                                    <td>
                                                        <div className="tableBox">
                                                            <div className='Adminprofileimageuser'>
                                                                <Skeleton width={"50px"} height={"50px"} circle />
                                                            </div>
                                                            <div className='Namedetails'>
                                                                <h4 className='namelink mb4 navigatetext'>{<Skeleton width={"100px"} />}</h4>
                                                                <p className="text2">{<Skeleton width={"150px"} />}</p>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className='tableBox dsblock'>
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                            <p className='text2'>{<Skeleton width={"60px"} />}</p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"200px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"100px"} />}</h4>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="tableBox">
                                                            <h4>{<Skeleton width={"40px"} />}</h4>
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <Skeleton width={"25px"} height={"25px"} circle />
                                                    </td>
                                                </tr>
                                            ))}
                                        </>}
                                </tbody>
                            </table>

                            {(!isMenteeFetching && (totalMentees?.length < allMentees?.totalCount)) && <div className="lodeemorebutton mt10" ref={targetRef}>
                                <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                            </div>}
                        </div>


                        {/* {(!isMenteeFetching && (totalMentees?.length < allMentees?.totalCount)) && <div className="lodeemorebutton mt10" ref={targetRef}>
                            <Button name={'Load More'} className={'BlueFillButton buttontext'} onClick={handleLoadMore} />
                        </div>} */}
                    </div>
                </div>
            </div>
        </>

    )
}

export default AdMentee